import { mdiShareVariantOutline } from "@mdi/js";

const social = [
  {
    title: "Social",
    icon: mdiShareVariantOutline,
    resource: "audience",
    action: "manage",
    children: [
      {
        title: "Reporting Social",
        to: "audience-social-reporting",
        resource: "audience",
        action: "manage",
      },
      {
        title: "Revenus",
        to: "audience-social-revenues",
        resource: "audience",
        action: "manage",
      },
      {
        title: "Crawlers",
        to: "audience-social-crawlers",
        resource: "audience",
        action: "manage",
      },
      {
        title: "Dashboard YT",
        to: "audience-social-youtube",
        resource: "audience",
        action: "manage",
      },
    ],
  },
];

export default social;
